import React, { Component } from 'react'
import { withRouter} from 'react-router-dom'
import { connect } from 'react-redux'
import SideNav from '../../components/navigation/SideNav'
import { showNewSectionModal,showManageSectionsModal,showNewRepoModal,showEditRepoModal,hideModal } from '../../actions/modals'
import { newRepo } from '../../actions/repos'
import sortBy from 'lodash/sortBy'
import {createPoll} from '../../utils/createPoll' 
import {showNotification} from '../../actions/notifications'
import {moveToRepo} from '../../utils/moveToRepo'


const navBarIsVisible = (location) => { 	
	if(
		!(location.pathname.indexOf('/seteditor/')>-1)  && 
		!(location.pathname.indexOf('/editor/')>-1)  && 
		!(location.pathname.indexOf('/liveview')>-1)  &&
		!(location.pathname.indexOf('/scoresheet')>-1)  &&
		!(location.pathname.indexOf('/classRoster/')>-1)  &&
		!(location.pathname.indexOf('/integration/')>-1)  &&
		!(location.pathname === '/classRoster/')  &&
		!(location.pathname.indexOf('/confirm-email')>-1)  &&
		!(location.pathname.indexOf('/dnd')>-1)  &&
		!(location.pathname.indexOf('/scan-helper')>-1)  &&
		!(location.pathname.indexOf('/import-questions-helper')>-1)  

	) return true
	else return false

}


class SideNavContainer extends Component {

	shouldComponentUpdate(nextProps) {
	    if((nextProps.location.pathname !== this.props.location.pathname)
	    		|| (nextProps.sections !==this.props.sections)
	    		|| (nextProps.repos !==this.props.repos)
	    		){	
	    		return true
	    	}else return null
	  	
	  	}

	render() {
		if(navBarIsVisible(this.props.history.location)){
			return (        
				<SideNav
					sections={this.props.sections}
					showNewSectionModal={this.props.showNewSectionModal}
					showManageSectionsModal={this.props.showManageSectionsModal}	
					newRepo={this.props.showNewRepoModal}
					repos={this.props.repos}
					createPoll={this.props.createPoll}
					showNotification={this.props.showNotification}
					moveToRepo={this.props.moveToRepo}
					showEditRepoModal={this.props.showEditRepoModal}
					hideModal={this.props.hideModal}


				/> 
			)
		}else return null
	}
}
 
export default withRouter(connect(
	(state,ownProps) => ({
		sections:state.sections,
		repos:sortBy(state.repos,[repo => repo.name.toLowerCase()]),

	}),
	{ 	showNewSectionModal,
		showManageSectionsModal,
		newRepo,
		createPoll,
		showNotification,
		showNewRepoModal,
		showEditRepoModal,
		moveToRepo,
		hideModal}
)(SideNavContainer))



// WEBPACK FOOTER //
// ./src/containers/navigation/SideNavContainer.js